<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    transition="dialog-bottom-transition"
    scrollable
    max-width="80%">
    <v-card>
      <v-toolbar text dark color="primary" style="max-height: 65px;">
        <v-btn icon dark class="hidden-md-and-up" @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Zeitnachweis bearbeiten</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn text :disabled="!submitAllowed" v-show="$vuetify.breakpoint.sm" @click.native="updateServiceTracking">
            Zeitnachweis bearbeiten
          </v-btn>
          <v-btn icon :disabled="!submitAllowed" v-show="$vuetify.breakpoint.xs" @click.native="updateServiceTracking">
            <v-icon right>save</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-select
                  :items="customers"
                  item-value="id"
                  return-object
                  v-model="selectedCustomer"
                  label="Kunde"
                  required
                  :rules="mandatoryFieldRule"
                  append-outer-icon="help"
                  @click:append-outer="showInfos = !showInfos"
                >
                  <template slot="selection" slot-scope="data">
                    <v-list-item-content>
                      <v-list-item-title>{{data.item.lastName}} {{data.item.firstName}}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <template slot="item" slot-scope="data">
                    <v-list-item-content>
                      <v-list-item-title>{{data.item.lastName}} {{data.item.firstName}}</v-list-item-title>
                      <v-list-item-subtitle>{{data.item.street}}, {{data.item.zipCode}} {{data.item.city}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-select>
                <v-dialog
                  v-model="showInfos"
                >
                  <v-card>
                    <v-app-bar flat dark color="primary">
                      <v-toolbar-title>Hinweise</v-toolbar-title>
                    </v-app-bar>
                    <v-card>
                      <v-card-text v-if="selectedCustomer && selectedCustomer.infos">
                        {{selectedCustomer.infos}}
                      </v-card-text>
                      <v-card-text v-else>
                        Keine Hinweise vorhanden.
                      </v-card-text>
                    </v-card>
                  </v-card>
                </v-dialog>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="services"
                  item-text="name"
                  item-value="id"
                  return-object
                  v-model="serviceTracking.service"
                  label="Dienstleistung"
                  required
                  :rules="mandatoryFieldRule"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="warning" icon="warning">
                      Bitte zuerst einen Kunden auswählen
                    </v-alert>
                </template>
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <el-date-picker
                  v-model="serviceTracking.date"
                  type="date"
                  placeholder="Datum auswählen"
                  format="dd.MM.yyyy"
                  value-format="timestamp"
                  :rules="mandatoryFieldRule"
                  :disabled="disabledDate(serviceTracking.date)"
                >
                </el-date-picker>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <el-time-select
                  placeholder="Startzeit auswählen"
                  format="HH:mm"
                  value-format="timestamp"
                  v-model="serviceTracking.startTime"
                  :picker-options="timerPickerOptions"
                  :rules="mandatoryFieldRule"
                >
                </el-time-select>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <el-time-select
                  placeholder="Endzeit auswählen"
                  format="HH:mm"
                  value-format="timestamp"
                  v-model="serviceTracking.finishTime"
                  :picker-options="{
                    start: timerPickerOptions.start,
                    step: timerPickerOptions.step,
                    end: timerPickerOptions.end,
                    minTime: serviceTracking.startTime
                  }"
                  :rules="mandatoryFieldRule"
                >
                </el-time-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="hidden-sm-and-down">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('close')">Abbrechen</v-btn>
        <v-btn
          :disabled="!submitAllowed"
          :loading="loading"
          color="primary"
          text
          @click="updateServiceTracking">
          Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'EditServiceTrackingDialog',
    props: {
      show: {
        type: Boolean,
        default: false
      },
      serviceTracking: {
        type: Object,
        default: function () {
          return {
            user: null,
            customer: null,
            service: null,
            date: null,
            startTime: null,
            finishTime: null,
            approachCharge: false
          }
        }
      }
    },
    data () {
      return {
        services: [],
        customers: [],
        selectedCustomer: null,
        showInfos: false,
        valid: false,
        timerPickerOptions: {
          start: '07:00',
          step: '00:15',
          end: '22:00'
        },
        datePickerOptions: {
          disabledDate (date) {
            const today = new Date()
            const priorDate = new Date(new Date().setDate(today.getDate() - 60))
            return date < priorDate || date > today
          }
        },
        mandatoryFieldRule: [
          v => !!v || 'Dieses Feld darf nicht leer sein'
        ]
      }
    },
    computed: {
      loading: function () {
        return this.$store.getters.loading
      },
      submitAllowed () {
        return this.serviceTracking.customer !== null &&
          this.serviceTracking.service !== null &&
          this.serviceTracking.date !== null &&
          this.serviceTracking.startTime !== null &&
          this.serviceTracking.finishTime !== null
      }
    },
    watch: {
      serviceTracking: function (newTracking) {
        this.selectedCustomer = newTracking.customer
        this.customers = newTracking.user.customers
      },
      selectedCustomer: function (newCustomer) {
        if (newCustomer) {
          this.serviceTracking.customer = newCustomer
          const definitions = this.customers.find(customer => customer.id === newCustomer.id).customerServiceDefinitions
          definitions.forEach(definition => this.services.push(definition.service))
        }
      }
    },
    methods: {
      updateServiceTracking () {
        this.$store.dispatch('updateServiceTrackingOfMy', {
          id: this.serviceTracking.id,
          user: this.serviceTracking.user,
          customer: this.serviceTracking.customer,
          service: this.serviceTracking.service,
          startTime: this.calcTime(this.serviceTracking.date, this.serviceTracking.startTime),
          finishTime: this.calcTime(this.serviceTracking.date, this.serviceTracking.finishTime),
          approachCharge: this.serviceTracking.approachCharge
        })
          .finally(() => this.$emit('close'))
      },
      calcTime (date, time) {
        const t = time.split(':')
        return date + (t[0] * 60 * 60000 + t[1] * 60000)
      },
      disabledDate (date) {
        const today = new Date()
        const priorDate = new Date(new Date().setDate(today.getDate() - 60))
        return date < priorDate
      }
    }
  }
</script>

<style>
  .el-date-editor.el-input {
    width: 100%;
  }
  .el-date-table td.today span {
    color: white;
    background-color: #409EFF75;
    border-radius: 50%;
  }
  .el-date-table td.current:not(.disabled) span {
    background-color: #2e7d32;
  }
</style>



// WEBPACK FOOTER //
// src/components/ServiceTracking/EditServiceTrackingDialog.vue